import { defineComponent as _defineComponent } from 'vue'
import html2canvas from 'html2canvas';
import { v4 as uuidv4 } from 'uuid';
import {
  onMounted, PropType, ref, watch,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HtmlImage',
  props: {
  html: { type: Object as PropType<string | undefined>, required: true },
  fillHeight: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props;

const previewImg = ref(undefined as undefined | HTMLImageElement);
const previewIframe = ref(undefined as undefined | HTMLIFrameElement);



const skeleton = ref(true);

const renderImage = () => {
  skeleton.value = true;

  const iframe = previewIframe.value;
  if (!iframe) {
    console.log('[renderImage] No Iframe Element?');
    return;
  }
  console.log(props.html);

  iframe.srcdoc = `
      <style>
        body {margin: 0 !important}
        body > div:first-of-type {
            xmin-width: 100vw !important;
            width: 100% !important;
            align-content: center !important;
        };
      </style>${props.html}`;

  iframe.onload = async () => {
    if (!iframe.contentDocument) {
      console.log('[renderImage] No Iframe Document?');
      return;
    }

    const canvas = await html2canvas(iframe.contentDocument.body, {
      allowTaint: true,
      imageTimeout: 2000,
      useCORS: true,
    });

    const imageDataUrl = canvas.toDataURL('image/png');
    skeleton.value = false;

    previewImg.value!.src = `${imageDataUrl}`;

    // const canvasW = canvas.width;
    // const canvasH = canvas.height;
    // console.log(`[renderImage] w:${canvasW} h:${canvasH}`);
    // td.style.paddingBottom = `${(canvasH / canvasW) * 100}%`;

    iframe.srcdoc = '';
    iframe.onload = null;
  };
};

onMounted(() => renderImage());

watch(
  () => props.html,
  () => { renderImage(); },
);


return { __sfc: true,previewImg, previewIframe, props, skeleton, renderImage, uuidv4 }
}

})